import React, { Component } from 'react';
import { Link } from 'veloe-ds';
import './returnPedidoConcluido.scss';
import { ImgGooglePlay, ImgAppStore, ContainerMobileStores } from './styles';
import CustomLink from '../../Components/CustomLink';
import { eventTrackRoute } from '../../utils/pushDataLayer.js';

class ReturnPedidoConcluido extends Component {
  componentDidMount = () => {
    eventTrackRoute('return-pedido-concluido');
    localStorage.clear();
  };

  render() {
    return (
      <div className="containerComponentDark">
        <div className="containerText">
          <div className="containerLabel">
            <div className="containerImg">
              <img src={require('../../assets/logo2x.png')} alt="" />
            </div>
          </div>
          <div className="spacer" />
          <br />
          <div className="containerImg">
            <img
              src={require('../../assets/returnPedidoPage/womanInLogo.png')}
              alt=""
            />
          </div>
        </div>
        <div className="containerArea">
          <div className="containerPedidoConcluido">
            <div className="containerDescPedidoConcluido">
              <h1 className="titulo-pedido-concluido">
                Espere aí, que tal baixar o App?
              </h1>
              <label className="previsao">
                <b>
                  Assim, você tem controle do seu consumo, acesso a facilidades,
                  descontos e muito mais.
                </b>
              </label>
              <div className="spacer" />
            </div>
            <div className="pedidoConcluidoFooter">
              <ContainerMobileStores>
                <CustomLink
                  to="https://play.google.com/store/apps/details?id=br.com.veloe.mobile"
                  tagLabel="googleplay"
                  img
                >
                  <ImgGooglePlay
                    src={require('../../assets/returnPedidoPage/google-play.png')}
                    alt="Google Play Logo"
                  />
                </CustomLink>
                <CustomLink
                  to="https://itunes.apple.com/us/app/veloe/id1278343398"
                  tagLabel="appstore"
                  img
                >
                  <ImgAppStore
                    src={require('../../assets/returnPedidoPage/app-store.png')}
                    alt="App Store Logo"
                  />
                </CustomLink>
              </ContainerMobileStores>
              <div className="spacer" />
              <br />
              <br />
              <br />
              <Link
                {...{
                  color: 'primary',
                  onBg: 'dark',
                  href: 'http://www.veloe.com.br',
                }}
              >
                {' '}
                Ir para home{' '}
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ReturnPedidoConcluido;
